export enum MessageType {
  Menu = 1,
  Event = 2,
  Order = 3,
  Warning = 4,
  PaymentEvent = 5,
}
